import React from 'react';
import { ClearRefinements, Menu, MenuSelect } from 'react-instantsearch-dom';
import useViewport from './useViewport';

interface CustomMenuFilterProps {
    seeAllText: string;
    filterAttribute: string;
    responsiveBreakpoint?: number;
    selectedAttribute?: string;
}

const CustomMenuFilter = ({ seeAllText, filterAttribute, responsiveBreakpoint, selectedAttribute }: CustomMenuFilterProps) => {
    const { width } = useViewport();
    const breakpoint = responsiveBreakpoint ? responsiveBreakpoint : 768;

    if (width > breakpoint) {
        return (
            <div className="custom-menu-filter desktop-version">
                <ClearRefinements
                    translations={{ reset: seeAllText }}
                />

                <Menu
                    attribute={filterAttribute}
                    defaultRefinement={selectedAttribute}
                />
            </div>
        );
    }

    return (
        <div className="custom-menu-filter mobile-version">
            <p>Displaying</p>
            <MenuSelect
                attribute={filterAttribute}
                defaultRefinement={selectedAttribute}
                translations={{ seeAllOption: seeAllText }}
            />
        </div>
    );
};

export default CustomMenuFilter;
